"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deliveryFees = deliveryFees;
// Traduction directe de getOrderDeliveryFees (apps/os/src/v1/lib/promotion.ts:171-187) :
// seuil comparé au total après remises (v1, R8/§3.2). Taxe des frais fournie
// par l'appelant, jamais retrouvée par nom (R8) — voir compute-order.ts.
function deliveryFees(input) {
    if (input.mode !== 'DELIVERY' || !input.zone) {
        return 0;
    }
    const { amount, reducedAmount, reducedThreshold } = input.zone;
    if (typeof reducedAmount === 'number' &&
        typeof reducedThreshold === 'number' &&
        input.totalAfterDiscounts >= reducedThreshold) {
        return reducedAmount;
    }
    if (typeof amount === 'number') {
        return amount;
    }
    return 0;
}
